import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const Container = styled.div(
  ({theme}) => css`
    width: 90px;
    /* @FIXME should be set in the toolkit component */
    font-family: ${theme.fontFamily};

    ${theme.respondTo(
      'md',
      css`
        width: max-content;
        max-width: 328px;
      `
    )}

    a:hover {
      text-decoration: none;
    }
  `
);
